import { Link } from "react-router-dom";
import "../Css/Admin.css";
import "./css/dropdown.css";
import DataList from "./DataList";
import { useState } from "react";
import { useEffect } from "react"
import axios from "axios";
import { Dropdown } from 'primereact/dropdown';

export default function ListTools() {


    const options = [
        {name: 'cocktail' },
        {name: 'repas' },
        {name: 'brunch' },
        {name: 'reinit' },
      ]
      

    const [sondage,setSondage] = useState([]);
    const [searchQuery, setSearchQuery] = useState({
        search:""
    })
    const [option, setOption] = useState({name:"reinit"})
    const [stats, setStats] = useState({
        total: 0,
        cocktail: 0,
        repas: 0,
        brunch: 0,
    })

    useEffect(() =>{
        const fetchAvis = async ()=>{
            try
            {
                console.log(option);
                const res = await axios.get("https://mariage-bs.ch:4006/sondages", { params: { filter: searchQuery.search, option : option.name}});
                const nb_cocktail = await axios.get('https://mariage-bs.ch:4006/countSondage', { params: { column: 'cocktail' }});
                const nb_repas = await axios.get('https://mariage-bs.ch:4006/countSondage', { params: { column: 'repas' }});
                const nb_brunch = await axios.get('https://mariage-bs.ch:4006/countSondage', { params: { column: 'brunch' }});
                stats.total = res.data.length;
                stats.cocktail = nb_cocktail.data[0].cocktail;
                stats.repas = nb_repas.data[0].repas;
                stats.brunch = nb_brunch.data[0].brunch;
                setSondage(res.data);
            }
            catch(err)
            {
                console.log(err);
            }
        }
        fetchAvis();
    },[searchQuery,option]);
    

    const handleChange = e =>{
        setSearchQuery(prev=>({[e.target.name]: e.target.value }));
        console.log(searchQuery.search)
    }

  return (    
    <div className="tools-list-container">
        <div className="tools-container">
            <div className="stats">
                <div className="stats-total stat-square"><div className="stat-header">Total</div> <div className="stat-value">{sondage.length}</div></div>
                <div className="stats-cocktail stat-square"><div className="stat-header">Cocktail</div> <div className="stat-value">{stats.cocktail}</div></div>
                <div className="stats-supper stat-square"><div className="stat-header">Repas</div> <div className="stat-value">{stats.repas}</div></div>
                <div className="stats-brunch stat-square"><div className="stat-header">Brunch</div> <div className="stat-value">{stats.brunch}</div></div>
            </div>
            <div className="tools">
                <input className="txt-search" type="text" name="search" onChange={handleChange} placeholder="Chercher par nom"></input>
                <Dropdown value={option} onChange={(e) => setOption(e.value)} options={options} optionLabel="name" 
                placeholder="choisir un filtre" className="w-full md:w-14rem" />
            </div>
        </div>
        <DataList sondage={sondage}></DataList>
    </div>
             
  );
}